import { ModalSweetAlert, Notificacion } from "@components/general/Alertas/Alertas";
import TitleDashboard from "@components/general/Titles/TitleDashboard";
import GridPaquetes from "@components/usuario/CompraLicencia/GridPaquetes";
import AvisoPrivacidad from "@components/usuario/CompraLicencia/modals/avisoPrivacidad/AvisoPrivacidad";
import DirectorioTelefonico from "@components/usuario/CompraLicencia/modals/directorioTelefonico/DirectorioTelefonico";
import UserContext from "@context/User/UserContext";
import useWindowResize from "@customHooks/useWindowResize";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dashboardRoutesPaths from "@helpers/dashboardRoutesPaths/dashboardRoutesPaths";
import { createCheckoutSession, getPriceLiquidacion } from "@helpers/httpRequests/httpRequestsPagos/httpRequestsPagos";
import { extraerRegionesSai } from "@helpers/httpRequests/httpRequestsSAI/httpRequestsSAI";
import Loader from "@helpers/loader/loader";
import FormularioNuevaCompra from "@helpers/paymentIntent/FormularioNuevaCompra";
import stripe from "@helpers/stripe/stripe";
import { CssBaseline, ThemeProvider, Typography, createTheme } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Container, FloatingLabel, Form, Image, Navbar, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import InfoKueski from "@helpers/kueski/modales/InfoKueski";

// const stripePromiseLive = loadStripe("pk_live_51IE0gOFjRsT0gjxgx2Phi43JYhjKNMrsWrrUMo5Fp4lew8xWwGZtxUUscs1XPG3QtflOi8KQnlm7c4Wd9njeXUrR00qKYiy86I")
// const stripePromiseTest = loadStripe("pk_test_51IE0gOFjRsT0gjxg9MtRKLzHSYaYxKJHiJiryN4OqfytvSexyDFBUvuf2MZfL4A3qecujZ4Os14GAlyjLD570jII00KYH97ErX")


const LiquidacionLicencia = () => {
	const urlParams = new URLSearchParams(useLocation().search);

	const { contextValue, setContextValue } = useContext(UserContext);

	const [showLoader, setShowLoader] = useState(true);

	const [loading, setLoading] = useState(false);

	const [showModalAvisoPrivacidad, setShowModalAvisoPrivacidad] = useState(false);

	const [showModalDirectorioTelefonico, setShowModalDirectorioTelefonico] = useState(false);

	const [precioStripe, setPrecioStripe] = useState("");

	const [folioContrato, setFolioContrato] = useState("");

	const [montoLiquidacion, setMontoLiquidacion] = useState("");

	const [esCompraExterna, setEsCompraExterna] = useState(false);

	const [regionesSai, setRegionesSai] = useState([]);

	const [regionSeleccionada, setRegionSeleccionada] = useState(0);

	const [diferidoPermitido, setDiferidoPermitido] = useState(0);

	// const [stripePromise, setStripePromise] = useState(stripePromiseLive);

	const darkTheme = createTheme({
		palette: {
			mode: "light",
		},
	});

	const {
		size: { width },
	} = useWindowResize();

	const handleClickAvisoPrivacidad = () => {
		setShowModalAvisoPrivacidad(!showModalAvisoPrivacidad);
	};

	const handleClickDirectorioTelefonico = () => {
		setShowModalDirectorioTelefonico(!showModalDirectorioTelefonico);
	};

	const handleClickPreguntasFrecuentes = () => {
		let link = document.createElement("a");

		link.href = "https://globalclickmexico.com/faq/index.html";

		link.target = "_blank";

		link.dispatchEvent(new MouseEvent("click"));
	};

	const handleOnChange = ({ target }) => {
		const {value, name} = target;

		switch (name) {
			case "folioContrato":
				setFolioContrato(target.value.replace(/\D/g, ""));
				break;
			case "monto":
				if(value === ""){
					setMontoLiquidacion("0")
				}else{
					setMontoLiquidacion(value);
				}
				break;
		
			default:
				break;
		}

	};

	const generarCheckout = async (folioContratoParam = null) => {
		try {
			const sessionData = {
				success_url: `${window.location.origin}${dashboardRoutesPaths.pagos.liquidacionRealizada}${esCompraExterna ? '?license-solved=true' : ''}`,
				cancel_url: folioContratoParam === null ? `${window.location.origin}${dashboardRoutesPaths.pagos.liquidacionLicencia}${esCompraExterna ? '?total-payment=true': ''}` : `${window.location.origin}${dashboardRoutesPaths.pagos.liquidacionLicencia}?folioContrato=${folioContratoParam}${esCompraExterna ? '?total-payment=true' : ''}`,
				line_items: [{ price: precioStripe, quantity: 1 }],
				mode: "payment",
				currency: esCompraExterna ? "usd" : "mxn",
				metadata: {
					folioContrato: folioContratoParam === null ? folioContrato : folioContratoParam,
					metodoPago: "contado",
				},
			};

			const checkoutSession = await createCheckoutSession(sessionData);

			if (urlParams.get("folioContrato") === null) {
				const { isConfirmed } = await Swal.fire({
					title: "Saliendo de Click+",
					text: "Estás a punto de ser redirigido al sitio de pago",
					showCancelButton: true,
					reverseButtons: true,
					confirmButtonText: "Entendido",
					cancelButtonText: "Cancelar",
					confirmButtonColor: "#0d6efd",
					allowOutsideClick: false,
				});
	
				if (!isConfirmed) {
					return Notificacion("info", "El pago fue cancelado");
				}
			}

			setContextValue({
				...contextValue,
				stripeSession: checkoutSession,
				folioContrato: folioContratoParam === null ? folioContrato : folioContratoParam,
				isMobile: folioContratoParam === null ? false : true
			});

			await (await stripe).redirectToCheckout({ sessionId: checkoutSession.id });
		} catch (error) {
			console.log("error al generar el checkout: ", error);
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		try {
			setLoading(true);

			await generarCheckout();

			if (urlParams.get("folioContrato") === null) {
				setLoading(false);
			}
		} catch (error) {
			console.log("error al iniciar el pago de abono: ", error);

			setLoading(false);
		}
	};

	const consultarPrecioLiquidacion = async () => {
		try {

			//Se reciben los datos para manejarlos en la vista pública
			const param = new URLSearchParams(window.location.search);

			const datosURL = param.get("total-payment");
			//Transformamos el string del data en arreglo

			//Si la variable datosURL es diferente de null es una compra fuera de México

			const { idPrecio } = await getPriceLiquidacion(datosURL ? true : false);

			setPrecioStripe(idPrecio);

			if (urlParams.get("folioContrato") === null) {
				setShowLoader(false);
			}
		} catch (error) {
			console.log("error al iniciar el pago de abono: ", error);
		}
	};

	const consultarRegiones = async() => {
			try{
				const regiones = await extraerRegionesSai();
				console.log(regiones)
				if(Array.isArray(regiones.data)){
					setRegionesSai(regiones.data);
				}else{
					setRegionesSai([regiones.data]);
				}
			}catch(error){
				console.log("Hubo un error al recuperar las regiones del SAI");
			}
		};

	const calcularMSI = () =>{

		if(montoLiquidacion >= 1000 && montoLiquidacion <= 2000){
			setDiferidoPermitido(6)
			console.log(6)
		}else if(montoLiquidacion >= 2001 && montoLiquidacion <= 3500){
			setDiferidoPermitido(9)
			console.log(9)
				
		}else{
			setDiferidoPermitido(12)
			console.log(12)
		}
		
	}
	
	const handleOnChangeRegion = ({target}) => {
		const {name, value} = target;
		console.log(name, value)
		setRegionSeleccionada(parseInt(value))
	};

		const handleKueskiInfo = ({ currentTarget }) => {
			ModalSweetAlert({
				title: "",
				html: <InfoKueski />,
				showConfirmButton: false,
				showCloseButton: true,
				width: "700px",
				height: "850px"
			});
		};

	useEffect(() => {
		// setShowLoader(false);
		// if(window.location.origin.includes('localhost') || window.location.origin.includes('qacursos')){
		// 	setStripePromise(stripePromiseTest);
		// }

		 //Se reciben los datos para manejarlos en la vista pública
		 const param = new URLSearchParams(window.location.search);

		 const datosURL = param.get("total-payment");
		 //Transformamos el string del data en arreglo
		 console.log(datosURL);

		 consultarRegiones();

		 if(datosURL !== null) {
			setEsCompraExterna(true);
		 }

		 //Si la variable datosURL es diferente de null es una compra fuera de México

		if (precioStripe === "") {
			consultarPrecioLiquidacion();
		}
	}, []);

	useEffect(() => {
		if (precioStripe !== "") {
			const folioContratoParam = urlParams.get("folioContrato");

			console.log("folio param: ", folioContratoParam);

			if (folioContratoParam !== null) {
				// setFolioContrato(folioContratoParam);

				generarCheckout(folioContratoParam);

				// formRef?.current.click();
			}
		}
	}, [precioStripe]);

	useEffect(() => {
		calcularMSI();
	}, [montoLiquidacion])
	

	return (
		<>
			{showLoader ? (
				<Loader />
			) : (
				<ThemeProvider theme={darkTheme}>
					<CssBaseline />

					<div data-bs-theme="light" className="bg-main-container d-flex flex-column" style={{ overflow: "hidden", overflowY: "scroll" }}>
						<Navbar expand="lg" bg="dark" className="bg-dark-custom">
							<Container fluid>
								<Navbar.Brand href="#">
									<div className="m-1">
										<img className="pointer" src={require(`@assets/images/logo-gc-horizontal.png`)} alt="Logo Global Click" style={{ width: `${width > 992 ? "10vw" : "20vw"}` }} />
									</div>
								</Navbar.Brand>

								<div className="text-white d-flex justify-content-end">
									<Typography variant="overline" className="pointer px-3 hover-orange" onClick={handleClickAvisoPrivacidad}>
										Aviso de privacidad
									</Typography>

									<Typography variant="overline" className="pointer px-3 hover-orange" onClick={handleClickPreguntasFrecuentes}>
										Preguntas frecuentes
									</Typography>

									<Typography variant="overline" className="pointer px-3 hover-orange" onClick={handleClickDirectorioTelefonico}>
										Directorio telefónico
									</Typography>
								</div>
							</Container>
						</Navbar>

						<Container className="py-30">
							<Row>
								<Col>
									<Container className="bg-blue-gc  card">
										<Row className="text-white">
											<Col>
												<Container className="py-3">
													<TitleDashboard title="Liquidación de Licencia Plataforma Click+" />

													<GridPaquetes />

													<TitleDashboard title="Opciones de pago" />
													<Row className="my-4">
														{/* <Col>
															<Image src={require("@assets/images/Kueski/banner.jpg")} fluid />
														</Col> */}
														<Col>
															<Card body className="bg-blue-gc text-white p-2" style={{border: "none"}}>

																<ul>
																	<li>De contado</li>
																	<li>Meses sin interéses (con tarjetas parcitipantes)</li>
																	
																</ul>

															</Card>
														</Col>
													</Row>

													<TitleDashboard title="¡Compra ahora, paga después!" />
													<Row className="my-4">
														{/* <Col>
															<Image src={require("@assets/images/Kueski/banner.jpg")} fluid />
														</Col> */}
														<Col>
															<Card body className="bg-blue-gc text-white p-2" style={{border: "none"}}>
																<h4>Realiza tu compra con <Image width="200" src={require("@assets/images/Kueski/logoKueski.png")} /> y aprovecha los beneficios que tiene para ti:</h4>
															<ul>
																<li>Paga hasta en 12 quincenas</li>
																<li>Compra diferida sin tarjeta de crédito</li>
																<li>Sin comisión por transacción</li>
																<li>Pago <b>100% seguro</b></li>
															</ul>

																<Button onClick={handleKueskiInfo} className="btn btn-primary">¿Cómo funciona?</Button>
															</Card>
														</Col>
													</Row>	
	



													<TitleDashboard title="Ingresa tu Folio de Contrato" />

													<Form onSubmit={handleSubmit} className="mt-3 mx-4">
														<Row className="mb-3">
																<Col>
																	<Form.Select name="region" onChange={handleOnChangeRegion} size="lg" aria-label="Default select example">
																		<option>Selecciona tu ubicación</option>
																		{regionesSai.map((region, idxRegion) => (
																			<option key={idxRegion} value={region.regionId}>{region.nombreRegion}</option>
																		))}
																	</Form.Select>
																</Col>
														</Row>
														<FloatingLabel label="Folio de Contrato" className="mb-3 text-dark">
															<Form.Control  maxLength={5} type="text" placeholder="Folio de contrato" name="folioContrato" value={folioContrato} onChange={handleOnChange} />
														</FloatingLabel>
														<FloatingLabel label="Monto a liquidar" className="mb-3 text-dark">
															<Form.Control maxLength={8} type="text" placeholder="Monto a liquidar" name="monto" value={montoLiquidacion} onChange={handleOnChange} />
														</FloatingLabel>

														{/* <div className="d-grid gap-2">
															<Button type="submit" variant="primary" size="lg">
																Pagar {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : null}
															</Button>
														</div> */}
													</Form>
													{(folioContrato !== "" && regionSeleccionada !== 0 && montoLiquidacion !== 0) && (
														<div className="mt-4 mb-4">
															
														
															{/* <Elements stripe={stripePromiseTest} > */}
																<FormularioNuevaCompra
																	idRegion={regionSeleccionada}
																	imgProducto={require("@assets/images/click.png")}
																	precioProducto={parseInt(montoLiquidacion) * 100}
																	precioProductoUSD={parseInt(montoLiquidacion) * 100}
																	nombreProducto={"Liquidación de licencia Click+ "}
																	compraExterna={esCompraExterna}
																	compraLectura={false}
																	compraKueski={esCompraExterna? false :true}
																	esLiquidacion={true}
																	folioContrato={folioContrato}
																	successUrl={`${dashboardRoutesPaths.pagos.liquidacionRealizada}${esCompraExterna ? '?license-solved=true' : ''}`}
																	msiEnabled={esCompraExterna? false: true}
																	msiMax={diferidoPermitido}
																	isMobile={urlParams.get("folioContrato") === null ? false : true}
																/>

															{/* </Elements> */}
														</div>
													)}
												</Container>
											</Col>
										</Row>
									</Container>
								</Col>
							</Row>
						</Container>

						<Container fluid className="p-0 align-content-end" style={{ flex: 1 }}>
							<Row>
								<Col>
									<Card>
										<Card.Body className="p-0">
											<Image fluid src={require("@assets/images/compra/compra-footer.jpg")} alt="Footer de Global Click México" className="w-100 h-100" />
										</Card.Body>
									</Card>
								</Col>
							</Row>
						</Container>

						<DirectorioTelefonico modalShow={showModalDirectorioTelefonico} setModalShow={setShowModalDirectorioTelefonico} />

						<AvisoPrivacidad modalShow={showModalAvisoPrivacidad} setModalShow={setShowModalAvisoPrivacidad} />
					</div>
				</ThemeProvider>
			)}
		</>
	);
};

export default LiquidacionLicencia;
